import * as React from 'react';
import { SVGProps } from 'react';

const IconAlertSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zM8 3a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1zm0 10c.608 0 1.1-.448 1.1-1s-.492-1-1.1-1c-.608 0-1.1.448-1.1 1s.492 1 1.1 1z"
    />
  </svg>
);
export default IconAlertSizeS;
